import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { environment } from 'src/environments/environment';

const API_MAIN = environment.segurity + environment.host + environment.version + environment.typeService;


@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  
  private excludedUrls: string[] = [
      API_MAIN + "province-api/get-all",
      API_MAIN + "city-api/get-all",
      API_MAIN + "tracking-api/get-products",
      API_MAIN + "tracking-api/calculate-sales-price",
  ];

  constructor(private loadingService: LoadingService) {}

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.isUrlExcluded(request.url)) {
      return next.handle(request);
    }

    this.loadingService.show();
    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.hide();
      })
    );
    
  }

  private isUrlExcluded(url: string): boolean {
    return this.excludedUrls.some(excludedUrl => url.startsWith(excludedUrl));
  }
}